import * as React from 'react';
import c from 'classnames';
import styles from './Menu.css';
import { useDispatch, useSelector } from 'react-redux';
import { SlideIn, SlideInHeader } from '../slidein';
import { Sorting } from '../comments';
import { SettingsOptions } from '../settingsoptions';
import {
  selectSettingsMenuState,
  changeSettingsMenuAction,
} from '../../ducks';
import { SettingsMenuViewButton } from './';
import { SETTINGSMENU } from '../../lib/labels';

export const SettingsMenu = () => {
  const settingsMenuActive = useSelector(selectSettingsMenuState);
  const dispatch = useDispatch();
  return (
    <SlideIn
      isActive={settingsMenuActive}
      changeActiveState={() => dispatch(changeSettingsMenuAction())}
    >
      <div className={c(styles.menu, 'menu')}>
        <SlideInHeader
          titleText={SETTINGSMENU.TITLE.SETTINGS}
          clickHandler={changeSettingsMenuAction(!settingsMenuActive)}
        />
        <SettingsOptions />
        <h3>{SETTINGSMENU.TITLE.SORT_COMMENTS}</h3>
        <Sorting menuSorting />
        <h3>{SETTINGSMENU.TITLE.VIEW}</h3>
        <SettingsMenuViewButton />
      </div>
    </SlideIn>
  );
};
